import React, { useState } from "react";
import PropTypes from "prop-types";
import { useMutation } from "@apollo/react-hooks";
import { TIME_CATEGORY, TIME_CATEGORY_SESSIONS } from "../queries";
import { DELETE_SESSION } from "../mutations";
import Modal from "../../core/components/Modal";
import alertIcon from "../../images/alert.svg";

const DeleteSessionModal = props => {
  /**
   * A full page interface asking if a session should be deleted.
   */

  const { showModal, setShowModal, session, category } = props;
  const [error, setError] = useState("");

  const [deleteSession, deleteSessionMutaion] = useMutation(DELETE_SESSION, {
    onError: () => {
      setError("Sorry there was an error, session couldn't be deleted.");
    },
    refetchQueries: [
      {query: TIME_CATEGORY, variables: {id: category.id}},
      {query: TIME_CATEGORY_SESSIONS, variables: {id: category.id}},
    ],
    onCompleted: () => {
      setShowModal(false);
    }
  });

  const formSubmit = e => {
    e.preventDefault();
    deleteSession({
      variables: {id: session.id}
    });
  }

  return (
    <Modal setShowModal={setShowModal} showModal={showModal} className="delete-modal delete-session-modal">
      <form onSubmit={formSubmit}>
        <img src={alertIcon} className="icon" alt="alert" />
        {error && <div className="error">{error}</div>}
        <div className="proposal">Delete Session '{session.notes}'</div>
        <div className="warning">This will permanently delete the session.</div>
        <input type="submit" value="Delete" disabled={deleteSessionMutaion.loading} />
      </form>
    </Modal>
  )
}

DeleteSessionModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  setShowModal: PropTypes.func.isRequired,
  session: PropTypes.object.isRequired,
  category: PropTypes.object.isRequired
}

export default DeleteSessionModal;







